import Http from "../engine/Http"
import { Identifiable } from "../model/Items"
import useAuthenticationHeader from "../security/AuthenticationHeader.hook";

const getResourceUrl = (customerId: number, priceListId: number, pricingId?: number) =>
  `api/customers/${customerId}/price-lists/${priceListId}/material-prices${getPricingIdUrlSuffix(pricingId)}`;

const getPricingIdUrlSuffix = (pricingId: number|undefined) => pricingId === undefined ? '' : `/${pricingId}`;

export interface IdentifiablePricing
extends Identifiable, Pricing {};

export interface Pricing {
  material: Identifiable;
  unitPrice: number;
}

const usePricingApi = () => {
  const authenticationHeader = useAuthenticationHeader();

  const fetchPricings = (customerId: number, priceListId: number): Promise<IdentifiablePricing[]> =>
    Http.get(getResourceUrl(customerId, priceListId), [ authenticationHeader ]);

  const updatePricing = (customerId: number, priceListId: number, pricingId: number, pricing: Pricing) =>
    Http.put(getResourceUrl(customerId, priceListId, pricingId), pricing, [ authenticationHeader ]);

  const createPricing = (customerId: number, priceListId: number, pricing: Pricing) =>
    Http.post(getResourceUrl(customerId, priceListId), pricing, [ authenticationHeader ]);

  return {
    fetchPricings,
    updatePricing,
    createPricing
  }
};

export default usePricingApi;